import {
  Backdrop as MuiBackdrop,
  CircularProgress,
  Box,
  useTheme,
} from "@mui/material";
import PropTypes from "prop-types";

const spinKeyframes = {
  "@keyframes backdropSpin": {
    "0%": { transform: "rotate(0deg)" },
    "100%": { transform: "rotate(360deg)" },
  },
};

const Backdrop = ({ fullOpacity }) => {
  const theme = useTheme();
  const iconUrl = process.env.REACT_APP_LOGO;

  const bgColor = fullOpacity
    ? theme.palette.background.paper
    : theme.palette.background.paper + "AA";

  return (
    <MuiBackdrop
      sx={{
        color: "white",
        zIndex: (theme) => theme.zIndex.drawer + 1,
        bgcolor: bgColor,
      }}
      open={true}
    >
      {iconUrl ? (
        <Box
          component="img"
          src={iconUrl}
          alt="loading"
          sx={{
            width: 96,
            height: 96,
            objectFit: "contain",
            animation: "backdropSpin 1s linear infinite",
            ...spinKeyframes,
          }}
        />
      ) : (
        <CircularProgress color="inherit" />
      )}
    </MuiBackdrop>
  );
};

Backdrop.propTypes = {
  fullOpacity: PropTypes.bool,
};

export default Backdrop;
